<template>
    <v-container>
      <div>
        <div style="background-color: rgb(230, 233, 242); padding-left: 20px; padding-right: 20px; padding-bottom: 15px;">
          <v-row>
            <v-col cols="12" md="12">
              <h2 style="font-size: 2.5rem; color: rgb(0, 30, 67)">Administración de IDmaderas</h2>
              ¡Bienvenido al panel de administración de <b style="color: rgb(0, 30, 67)">IDmaderas:</b>!<br><br>
              
              Esta sección está diseñada para facilitar la gestión de la información sobre especies maderables en nuestra plataforma. Como administrador, tendrás la capacidad de: 
              <li><b>Incorporar nuevas especies:</b> Agrega información detallada sobre nuevas especies maderables, incluyendo características anatómicas, nombres comunes y científicos, y otros datos relevantes.</li>
              <li><b>Editar información existente:</b> Actualiza y modifica fichas de especies para asegurar que la información proporcionada sea precisa y esté al día.</li>
              <li><b>Gestionar contenido:</b> Organiza y supervisa el contenido de la plataforma, garantizando que los recursos sean accesibles y útiles para los usuarios.</li>

              <br>
              Tu contribución es esencial para mantener <b style="color: rgb(0, 30, 67)">IDmaderas</b> como una herramienta confiable y actualizada. Asegúrate de seguir los lineamientos 
              establecidos para la incorporación de información, promoviendo así un recurso de calidad para todos los usuarios. 
            </v-col>
          </v-row>
        </div>
        <br>
        <div>
          <v-row class="mb-3 justify-center">
            <v-col class="mb-1" md="3"> 
              <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
                <router-link :to="{ name: 'textura' }" style="text-decoration: none;">
                  <v-tooltip bottom color="rgb(0, 124, 186)">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-img class="align-end text-white" contain height="100" :src="require('../assets/admin1.jpg')" style="margin-top: 5px;"></v-img>
                        <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Textura</p></b>
                      </div>
                    </template>
                    <span style="font-size: 0.9rem; color: white;">Enlace a Textura.</span>
                  </v-tooltip>
                </router-link>
              </v-card>
            </v-col>
            <v-col class="mb-1" md="3"> 
              <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
                <router-link :to="{ name: 'parenquima' }" style="text-decoration: none;">
                  <v-tooltip bottom color="rgb(0, 124, 186)">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-img class="align-end text-white" contain height="100" :src="require('../assets/admin2.png')" style="margin-top: 5px;"></v-img>
                        <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Parenquima</p></b>
                      </div>
                    </template>
                    <span style="font-size: 0.9rem; color: white;">Enlace a Parenquima.</span>
                  </v-tooltip>
                </router-link>
              </v-card>
            </v-col>
            <v-col class="mb-1" md="3"> 
              <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
                <router-link :to="{ name: 'poros' }" style="text-decoration: none;">
                  <v-tooltip bottom color="rgb(0, 124, 186)">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-img class="align-end text-white" contain height="100" :src="require('../assets/admin3.jpg')" style="margin-top: 5px;"></v-img>
                        <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Poros</p></b>
                      </div>
                    </template>
                    <span style="font-size: 0.9rem; color: white;">Enlace a Poros.</span>
                  </v-tooltip>
                </router-link>
              </v-card>
            </v-col>
            <v-col class="mb-1" md="3"> 
              <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
                <router-link :to="{ name: 'radios' }" style="text-decoration: none;">
                  <v-tooltip bottom color="rgb(0, 124, 186)">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-img class="align-end text-white" contain height="100" :src="require('../assets/admin4.jpg')" style="margin-top: 5px;"></v-img>
                        <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Radios</p></b>
                      </div>
                    </template>
                    <span style="font-size: 0.9rem; color: white;">Enlace a Radios.</span>
                  </v-tooltip>
                </router-link>
              </v-card>
            </v-col> 
            <v-col class="mb-1" md="3"> 
              <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
                <router-link :to="{ name: 'inclusiones' }" style="text-decoration: none;">
                  <v-tooltip bottom color="rgb(0, 124, 186)">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-img class="align-end text-white" contain height="100" :src="require('../assets/admin5.jpg')" style="margin-top: 5px;"></v-img>
                        <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Inclusiones</p></b>
                      </div>
                    </template>
                    <span style="font-size: 0.9rem; color: white;">Enlace a Inclusiones.</span>
                  </v-tooltip>
                </router-link>
              </v-card>
            </v-col> 
            <v-col class="mb-1" md="3"> 
              <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
                <router-link :to="{ name: 'rol' }" style="text-decoration: none;">
                  <v-tooltip bottom color="rgb(0, 124, 186)">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-img class="align-end text-white" contain height="100" :src="require('../assets/admin6.jpg')" style="margin-top: 5px;"></v-img>
                        <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Rol</p></b>
                      </div>
                    </template>
                    <span style="font-size: 0.9rem; color: white;">Enlace a Rol.</span>
                  </v-tooltip>
                </router-link>
              </v-card>
            </v-col>
            <v-col class="mb-12" md="3" v-if="rolOid === 1">
              <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
                <router-link :to="{ name: 'user' }" style="text-decoration: none;">
                  <v-tooltip bottom color="rgb(0, 124, 186)">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-img class="align-end text-white" contain height="100" :src="require('../assets/admin7.jpeg')" style="margin-top: 5px;"></v-img>
                        <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Usuarios</p></b>
                      </div>
                    </template>
                    <span style="font-size: 0.9rem; color: white;">Enlace a Usuarios.</span>
                  </v-tooltip>
                </router-link>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-container>
  </template>
  
<script>
export default {
  name: 'HelloWorld',

  data: () => ({
    
  }),
  computed: {
    rolOid() {
    // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
        const oid_rol = localStorage.getItem('rolu');
        return Number(oid_rol);
    },
  },
}
</script>
<style>
  p {
    font-family: 'Heebo', sans-serif !important;
      font-size: 17px;        
      line-height: 1.6em;
  }
  h1 {
    font-family: 'Heebo', sans-serif !important;
      font-size: 2.5rem;
  }
  h2 {
    font-family: 'Sofia Sans', sans-serif !important;
  }
  h3 {
    font-family: 'Sofia Sans', sans-serif !important;
  }
  h5 {
      font-family: 'Sofia Sans', sans-serif !important;
      font-size: 1.25rem;
  }
  
</style>